export const ONE_MB_IN_BYTES = 1048576;
